import { createSelector } from 'reselect';
import { getConfigData } from 'src/modules/config/selectors/getConfigData';

export const getConfigSchema = createSelector([
  getConfigData,
], (config) => config.schema);
